import { render } from "./EditTagTranslation.vue?vue&type=template&id=2d1e9d44&scoped=true&ts=true"
import script from "./EditTagTranslation.vue?vue&type=script&lang=ts"
export * from "./EditTagTranslation.vue?vue&type=script&lang=ts"

import "./EditTagTranslation.vue?vue&type=style&index=0&id=2d1e9d44&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1e9d44"]])

export default __exports__